export const MAX_DROPDOWN_ITEMS = 5;
export const MAX_N_CUSTOM_ATTRIBUTES = 4;
export const MAX_N_PRODUCTS = 10;
